webpackJsonp([104101334113578],{

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Button;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// color
	// backgroundColor
	// href
	function Button(props) {
	    return _react2.default.createElement(
	        'a',
	        { className: "button " + (props.color == "grey" ? "grey__sp21" : "blue__sp21"), href: props.href, target: '_blank' },
	        props.children
	    );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FadeInSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FadeInSection(props) {
	    var _useState = (0, _react.useState)(true),
	        isVisible = _useState[0],
	        setVisible = _useState[1];
	
	    var domRef = (0, _react.useRef)();
	    (0, _react.useEffect)(function () {
	        var observer = new IntersectionObserver(function (entries) {
	            entries.forEach(function (entry) {
	                return setVisible(entry.isIntersecting);
	            });
	        });
	        observer.observe(domRef.current);
	        return function () {
	            return observer.unobserve(domRef.current);
	        };
	    }, []);
	    var className = 'fade-in-' + props.dir;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: className + ' ' + (isVisible ? 'is-visible' : ''),
	            ref: domRef
	        },
	        props.content
	    );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = IndexPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(418);
	
	var _FloatIn = __webpack_require__(177);
	
	var _FloatIn2 = _interopRequireDefault(_FloatIn);
	
	var _links = __webpack_require__(18);
	
	var _Button = __webpack_require__(35);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var floatContent = [[{ content: "Calling", dir: "left" }, { content: "/img/homepage/CALLING-ALL.png", dir: "bottom" }, { content: "all", dir: "right" }], [{ content: "creatives...", dir: "left", font: "IM Fell French Canon" }], [{ content: "/img/homepage/DESIGNER-SP.svg", dir: "left" }, { content: "designers", dir: "bottom", font: "Prophet" }, { content: "/img/homepage/DESIGNER-IMG.png", dir: "right" }], [{ content: "/img/homepage/PHOTOGRAPHER-IMG.png", dir: "left" }, { content: "photographers", dir: "bottom", font: "" }, { content: "/img/homepage/PHOTOGRAPHER-SP.svg", dir: "right" }], [{ content: "/img/homepage/DEVELOPER-SP.svg", dir: "left" }, { content: "developers", dir: "bottom", font: "Mondwest" }, { content: "/img/homepage/DEVELOPER-IMG.png", dir: "right" }]];
	
	function SectionTwo(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'section__two' },
	    props.content.map(function (row) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'g__flex__row', style: { justifyContent: "center" } },
	        row.map(function (item) {
	          return _react2.default.createElement(_FloatIn2.default, {
	            content: item.content.startsWith("/") ? _react2.default.createElement('img', { className: 'float__img', src: item.content }) : _react2.default.createElement(
	              'div',
	              { className: 'l__text', style: { fontFamily: item.font } },
	              item.content
	            ),
	            dir: item.dir
	          });
	        })
	      );
	    })
	  );
	}
	
	var bannerContent = [{
	  title: "decals",
	  img: "/img/homepage/DECALS-IMG.png",
	  description: "We offer three student-led courses every semester to help beginners learn graphic design or photography principles.",
	  to: "/decals"
	}, {
	  title: "events",
	  img: "/img/homepage/EVENTS-IMG.png",
	  description: "We hold various semesterly events by inviting industry creative professionals.",
	  to: "/events",
	  flip: "true"
	}, {
	  title: "extensions",
	  img: "/img/homepage/EXTENSIONS-IMG.png",
	  description: "We mentor and provide resources to help students at other universities start their own Innovative Design chapter.",
	  to: "/extensions"
	}];
	
	function PageCard(props) {
	  var banner = props.banner;
	  return _react2.default.createElement(
	    'div',
	    { className: 'page__card' },
	    banner.flip ? _react2.default.createElement(
	      'div',
	      { className: 'g__flex__row banner__row' },
	      _react2.default.createElement(
	        'p',
	        { className: 'banner__desc' },
	        ' ',
	        banner.description,
	        ' '
	      ),
	      _react2.default.createElement('img', { src: banner.img, className: 'banner__img' })
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'g__flex__row banner__row' },
	      _react2.default.createElement('img', { src: banner.img, className: 'banner__img' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'banner__desc' },
	        ' ',
	        banner.description,
	        ' '
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'banner__title translate__y' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'banner__title', to: banner.to },
	        banner.title
	      )
	    )
	  );
	}
	
	function SectionThree(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'section__three' },
	    props.content.map(function (banner) {
	      return _react2.default.createElement(PageCard, { banner: banner });
	    })
	  );
	}
	
	// TODO
	function SectionOne(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'section__one' },
	    _react2.default.createElement(
	      'div',
	      { className: 'g__flex__col section__one__hero' },
	      _react2.default.createElement('img', { className: 'join__us__svg', src: '/img/homepage/front/join-us.svg' }),
	      _react2.default.createElement(
	        'h2',
	        { style: { fontFamily: "Sporting" } },
	        'Lets make something together.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Innovative Design is UC Berkeley\u2019s premier creative agency. We are designers, photographers, and web developers together in a mission to Make Berkeley Beautiful.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'home__button__wrapper' },
	      _react2.default.createElement(
	        _Button2.default,
	        { color: 'grey', href: _links.behanceClub },
	        'See our work'
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { color: 'blue', href: _links.applyRequest },
	        'Request services'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'graphics' },
	      _react2.default.createElement('img', { id: 'rachel', src: 'img/homepage/front/rachel.svg' }),
	      _react2.default.createElement('img', { id: 'computer', src: 'img/homepage/front/computer.svg' }),
	      _react2.default.createElement('img', { id: 'bottom-left', src: 'img/homepage/front/bottom-left.svg' }),
	      _react2.default.createElement('img', { id: 'bottom-right', src: 'img/homepage/front/bottom-right.svg' }),
	      _react2.default.createElement('img', { id: 'top-right', src: 'img/homepage/front/top-right.svg' })
	    )
	  );
	}
	
	function IndexPage(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'g__flex__column total__wrapper' },
	    _react2.default.createElement(SectionOne, null),
	    _react2.default.createElement(SectionTwo, { content: floatContent }),
	    _react2.default.createElement('hr', { className: 'vertical__line' }),
	    _react2.default.createElement(SectionThree, { content: bannerContent })
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-index-js-adcc026520a5b870662d.js